import React, { FC } from 'react';

import './Announcement.scss';

export interface AnnouncementProps {
  open?: boolean;
  onRequestClose?: () => void;
  children: React.ReactNode;
}

const Announcement: FC<AnnouncementProps> = ({ open, onRequestClose, children }) => {
  if (!open) {
    return null;
  }

  return (
    <div className="enkrateia-announcement">
      <div className="data">{children}</div>
      <button className="close" onClick={onRequestClose}>
        ×
      </button>
    </div>
  );
};

export default Announcement;
